/**
 * @generated SignedSource<<5227f3affcfc187dbec669efa90128bc>>
 * @relayHash 5553b8b9ee42e9c0dac6fce964c332e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8929b12ffcef613fa19c7c7754b36a5c34e49df215f92f9f6acdac6dc21dc9af

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneysPageQuery } from './JourneysPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneysPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8929b12ffcef613fa19c7c7754b36a5c34e49df215f92f9f6acdac6dc21dc9af",
    "metadata": {},
    "name": "JourneysPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
